import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { OiamService } from 'projects/suche-lib/src/lib/services/oiam/oiam.service';

@Component({
  selector: 'now-wbsuche-app-oiam-oauth',
  imports: [],
  templateUrl: `./oiam-oauth.component.html`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  // Hier wird CUSTOM_ELEMENTS_SCHEMA eingesetzt, da in dieser Component eine WebComponent eingebunden ist.
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class OiamOauthComponent {
  public oiamService: OiamService = inject(OiamService);
}
